module.exports = __webpack_public_path__ + "static/media/custom-01.21c48800.jpg";